module.exports = __webpack_public_path__ + "media/application/images/svgs/tv-6872361f2760d4be18328c3af6b84dc7.svg";